export default __webpack_public_path__ + "static/media/image.2aa5240a.svg";